import { render } from "./input-group-percentage.vue?vue&type=template&id=12f067f9"
import script from "./input-group-percentage.vue?vue&type=script&lang=js"
export * from "./input-group-percentage.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Cater-Frontend\\cater\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__